import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Bump APP_VERSION when you deploy so returning users get fresh session/storage
const APP_VERSION = '2';
const VERSION_KEY = 'bsb_app_version';
if (typeof window !== 'undefined') {
  const saved = sessionStorage.getItem(VERSION_KEY);
  if (saved !== APP_VERSION) {
    try {
      sessionStorage.clear();
      localStorage.clear();
      sessionStorage.setItem(VERSION_KEY, APP_VERSION);
    } catch (e) { /* ignore */ }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
